import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelSetpoints.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ModelSetpoints from './ModelSetpoints';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';

const ModelSetpointListTable = ({
  setEditHandler,
  selectedModelSetpointId,
  saveModelSetpoint,
  modelSetpoints,
  describeModelSetpoint,
  changeModelSetpoint,
  modelCategorySetpoints,
  paginatedData = [],
  UpdateAllowed,
  DeleteAllowed,
  ReadOnly,
  disableMode,
  disableModeHandler,
  addNewRef,
  removeModelSetpoint,
  IsModelCategoryOwner,
  intl
}) => {

  let { ModelId } = useParams()
  const lblYes = intl.formatMessage({ id: 'common.yes', defaultMessage: 'Yes' });
  const lblNo = intl.formatMessage({ id: 'common.no', defaultMessage: 'No' });

  const fetchDataHandler = modelSetpointId => {
    setEditHandler(modelSetpointId);
    disableModeHandler(true);
    describeModelSetpoint(ModelId, modelSetpointId);
  };

  const deleteDataHandler = modelSetpointId => {
    removeModelSetpoint(modelSetpointId);
  };

  const cancelHandler = () => {
    setEditHandler(-1);
    disableModeHandler(false);
  };

  const editModelContent = (
    <ModelSetpoints
      ModelSetpointId={selectedModelSetpointId}
      saveModelSetpoint={saveModelSetpoint}
      modelSetpoint={modelSetpoints}
      changeModelSetpoint={changeModelSetpoint}
      modelCategorySetpoints={modelCategorySetpoints}
      cancelHandler={cancelHandler}
    />);

  let editorMain = (
    <tr>
      <td colSpan="10">{editModelContent}</td>
    </tr>
  );

  let newRowClass = modelSetpoints.showAddEditScreen && selectedModelSetpointId === 0 ? s.newRow : '';

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelSetpoints.setpointGroup" defaultMessage="Setpoint Group" />
            </th>
            <th>
              <FormattedMessage id="modelSetpoints.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="modelSetpoints.code" defaultMessage="Code" />
            </th>
            <th>
              <FormattedMessage id="modelSetpoints.defaultValue" defaultMessage="Default Value" />
            </th>
            <th>
              <FormattedMessage id="modelSetpoint.uOM" defaultMessage="Unit of Measure" />
            </th>
            <th>
              <FormattedMessage id="common.isEditable" defaultMessage="Is Editable" />
            </th>

            {!ReadOnly && IsModelCategoryOwner && (UpdateAllowed || DeleteAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelSetpointId}>
                <tr key={n.ModelSetpointId} data-unittest="modelSetpointData">
                  <td>{n.SetpointGroup}</td>
                  <td>{n.Name}</td>
                  <td>{n.Code}</td>
                  <td>{n.Value}</td>
                  <td>{n.UnitOfMeasure}</td>
                  <td>{n.IsEditable ? lblYes : lblNo}</td>
                  {!ReadOnly && IsModelCategoryOwner && (UpdateAllowed || DeleteAllowed) && (
                    <td className={s.btnCol}>
                      {UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={fetchDataHandler.bind(this, n.ModelSetpointId)}
                          disabled={disableMode}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                        </Button>
                      )}
                      {DeleteAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={deleteDataHandler.bind(this, n.ModelSetpointId)}
                          disabled={disableMode}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="modelSetpoints.delete" defaultMessage="Delete" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
                {modelSetpoints.showAddEditScreen && selectedModelSetpointId === n.ModelSetpointId && editorMain}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
      <div className={newRowClass} ref={addNewRef}>
        {modelSetpoints.showAddEditScreen && selectedModelSetpointId === 0 && editModelContent}
      </div>
    </div>
  );
};


ModelSetpointListTable.propTypes = {
  setEditHandler: PropTypes.func.isRequired,
  selectedModelSetpointId: PropTypes.number,
  saveModelSetpoint: PropTypes.func.isRequired,
  modelSetpoints: PropTypes.object.isRequired,
  describeModelSetpoint: PropTypes.func.isRequired,
  changeModelSetpoint: PropTypes.func.isRequired,
  paginatedData: PropTypes.array,
  UpdateAllowed: PropTypes.bool,
  disableMode: PropTypes.bool,
  disableModeHandler: PropTypes.func.isRequired
};

export default injectIntl(ModelSetpointListTable);
